import { useMatomo } from '@datapunt/matomo-tracker-react';
import { Box, Button, CircularProgress, Fade, Grid } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { HomePageContainer } from './public-home.styles';
import bannerLogo from '../../../assets/images/logo_large.png';
import { CmsArticles, fetchCmsArticle } from '../../../shared/helpers/cms-articles';

const styles = {
  titleBanner: {
    backgroundColor: '#4090CB',
    color: '#ffffff',
    alignItems: 'center',
    padding: '10px'
  },
  cmsBackground: {
    backgroundColor: 'rgba(202,226,246,0.78)'
  },
  cmsBlock: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
    fontSize: '1.05rem !important'
  },
  whitespace: {
    backgroundColor: '#fafafa',
    height: '40%',
    paddingBottom: '5%'
  },
  imageBox: {
    justifyContent: 'center',
    backgroundColor: '#57aae8',
    height: '50%',
    display: 'flex',
    paddingBottom: '5%'
  },
  bannerLogo: {
    alignItems: 'center',
    width: '20%',
    marginLeft: '0.5%',
    marginTop: '5%',
    minWidth: '150px'
  },
  yellowBannerImg: {
    width: '100%'
  }
};

const PublicHome = () => {
  const [data, setData] = useState(localStorage.getItem('home') || '');
  const [isFetching, setIsFetching] = useState(false);
  const { trackPageView } = useMatomo();

  // Track page view
  useEffect(() => {
    trackPageView({});
  }, []);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        setIsFetching(true);
        const response = await fetchCmsArticle(CmsArticles.HOME_PAGE);
        localStorage.setItem('home', response || '');
        setData(response);
        setIsFetching(false);
      } catch (error) {
        if (setData) {
          setData('Error loading');
        }
        if (setIsFetching) {
          setIsFetching(false);
        }
      }
    };

    void fetchArticle();
  }, []);

  return (
    <HomePageContainer>
      <Grid container spacing={0}>
        <Grid item xs={12} sm={12} style={styles.cmsBackground}>
          <Grid container>
            <Grid item xs={12}>
              <Grid item sm={12} style={styles.whitespace}></Grid>
              <Box display={{ xs: 'none', sm: 'flex' }} style={styles.imageBox} alignItems="flex-end">
                <img src={bannerLogo} alt="banner" style={styles.bannerLogo} />
              </Box>
            </Grid>
            <Grid item xs={12} style={styles.cmsBlock}>
              <div className="lead" dangerouslySetInnerHTML={{ __html: data }} />
            </Grid>
            <Grid item xs={12} style={styles.cmsBlock}>
              <Fade in={isFetching} timeout={5}>
                <Box m="auto">
                  <CircularProgress />
                </Box>
              </Fade>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Fade in={!isFetching} timeout={5}>
        <Box m="auto" mt={4}>
          <Button component={Link} to="/applications" variant="contained" color="primary">
            Start Or Continue an Application
          </Button>
        </Box>
      </Fade>
    </HomePageContainer>
  );
};

export default PublicHome;
